export const mockData = {
  heroSlides: [
    {
      model: 'BJ60',
      image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
      description: 'Premium Off-Road SUV',
    },
    {
      model: 'BJ30',
      image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
      description: 'Compact Adventure SUV',
    },
    {
      model: 'BJ40',
      image: '/assets/images/bj40-pro/bj40pro2.jpg',
      description: 'Classic Off-Road Icon',
    },
  ],

  carModels: {
    'Off-road': [
      {
        name: 'BJ80',
        image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
        description: 'Luxury Off-Road Commander',
      },
      {
        name: 'BJ60',
        image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
        description: 'Premium Adventure SUV',
      },
      {
        name: 'BJ40 C',
        image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
        description: 'Classic Off-Road Heritage',
      },
      {
        name: 'BJ40 SE',
        image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
        description: 'Special Edition Off-Roader',
      },
      {
        name: 'F40',
        image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
        description: 'Future of Off-Road',
      },
    ],
    SUV: [
      {
        name: 'X55',
        image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
        description: 'Urban Smart SUV',
      },
      {
        name: 'X35',
        image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
        description: 'Compact City SUV',
      },
      {
        name: 'X7',
        image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
        description: 'Premium Family SUV',
      },
    ],
    Sedan: [
      {
        name: 'D50',
        image: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
        description: 'Executive Sedan',
      },
      {
        name: 'D20',
        image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
        description: 'Compact Sedan',
      },
    ],
  },

  featureCards: [
    {
      title: 'Research & Development',
      image: 'https://images.pexels.com/photos/65623/vehicle-chrome-technology-automobile-65623.jpeg',
      link: 'innovation/research-development',
    },
    {
      title: 'Off-Road Vehicle',
      image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
      link: 'innovation/off-road',
    },
    {
      title: 'BAIC History',
      image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
      link: 'about/history',
    },
    {
      title: 'Learn Everything About BAIC',
      image: 'https://images.pexels.com/photos/215528/pexels-photo-215528.jpeg',
      link: 'about/overview',
    },
  ],

  news: [
    {
      title: 'BAIC Ranked in Fortune Global 500',
      slug: 'baic-ranked-fortune-500',
      excerpt:
        'BAIC Group has achieved a prestigious ranking in the Fortune Global 500, showcasing our commitment to excellence and innovation in the automotive industry.',
      image: 'https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg',
      date: 'Jan 2025',
    },
    {
      title: 'Smart BAIC Technology Launch',
      slug: 'smart-baic-technology-launch',
      excerpt:
        'Introducing cutting-edge smart vehicle technology that redefines driving experience with AI-powered features and connected services.',
      image: 'https://images.pexels.com/photos/35290260/pexels-photo-35290260.jpeg',
      date: 'Dec 2024',
    },
    {
      title: 'New Manufacturing Facility Opens',
      slug: 'new-manufacturing-facility-opens',
      excerpt:
        'BAIC opens state-of-the-art manufacturing facility featuring advanced robotics and sustainable production processes.',
      image: 'https://images.pexels.com/photos/104401/pexels-photo-104401.jpeg',
      date: 'Nov 2024',
    },
  ],
};